import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import CloseBold from '../../../Icons/CloseBold';
import LargeSophisticatedTooltipContent from '../../LargeSophisticatedTooltipContent';
import MediumSophisticatedTooltipContent from '../../MediumSophisticatedTooltipContent';
import IconButton from '../../../Buttons/IconButton';
import PopoverWrapper from '../../../popper/PopoverWrapper';
import s from './SophisticatedTooltipContent.scss';
/** A more sophisticated tooltip with a `heading` and `description`.  */ const SophisticatedTooltipContent = (_param)=>{
    var { width, description, prefix, postfix, size, hasCloseButton, forceTheme = ThemeOptions.LIGHT, effectivePlacement, effectiveSecondaryPlacement, rootRef, arrowRef, arrowAttributes, arrowStyle, contentStyle, contentAttributes, updatePositioning, onMouseEnter, onMouseLeave, onClose, className, contentClassName } = _param, rest = _object_without_properties(_param, [
        "width",
        "description",
        "prefix",
        "postfix",
        "size",
        "hasCloseButton",
        "forceTheme",
        "effectivePlacement",
        "effectiveSecondaryPlacement",
        "rootRef",
        "arrowRef",
        "arrowAttributes",
        "arrowStyle",
        "contentStyle",
        "contentAttributes",
        "updatePositioning",
        "onMouseEnter",
        "onMouseLeave",
        "onClose",
        "className",
        "contentClassName"
    ]);
    const heading = rest.heading;
    const ariaLabel = rest['aria-label'];
    return /*#__PURE__*/ React.createElement(PopoverWrapper, {
        wrapperClassName: className,
        className: contentClassName,
        contentClassName: c(s['popover-wrapper'], s[`size-${size}`]),
        width: width,
        onClickOutside: onClose,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        effectivePlacement: effectivePlacement,
        effectiveSecondaryPlacement: effectiveSecondaryPlacement,
        rootRef: rootRef,
        arrowRef: arrowRef,
        contentStyle: contentStyle,
        arrowStyle: arrowStyle,
        contentAttributes: contentAttributes,
        arrowAttributes: arrowAttributes,
        updatePositioning: updatePositioning,
        forceTheme: forceTheme
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(hasCloseButton && s['close-button-padding'])
    }, /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: forceTheme
    }, size === 'medium' ? /*#__PURE__*/ React.createElement(MediumSophisticatedTooltipContent, {
        heading: heading,
        "aria-label": ariaLabel,
        description: description,
        prefix: prefix,
        postfix: postfix
    }) : /*#__PURE__*/ React.createElement(LargeSophisticatedTooltipContent, {
        heading: heading,
        "aria-label": ariaLabel,
        description: description,
        prefix: prefix,
        postfix: postfix
    }))), hasCloseButton && /*#__PURE__*/ React.createElement(IconButton, {
        icon: CloseBold,
        size: "small",
        className: s['close-button'],
        onClick: onClose
    }));
};
SophisticatedTooltipContent.displayName = 'SophisticatedTooltipContent';
export default SophisticatedTooltipContent;
